import React from 'react'
import bannerDesktop from "../assets/images/image-web-3-desktop.jpg"
import bannerMobile from "../assets/images/image-web-3-mobile.jpg"
import SideNews from './SideNews'

function MainArticle(props) {
    return (
        <div className="main-article">
            <picture className='banner-container'>
                <source srcSet={bannerDesktop} media='(min-width: 950px)' />
                <img src={bannerMobile} className="banner"
                    alt="banner"
                    width='730'
                    height='330'
                />
            </picture>
            <h1 className='article-title' tabIndex={0}>{props.title}</h1>
            <div className='article-body'>
                <a href='/' tabIndex={0} className="article-text">
                    {props.content}
                </a>
                <button className='article-button'>READ MORE</button>
            </div>
        </div>
    )
}

const MainNews = () => {
    return (
        <section className="main-news">
            <MainArticle
                title="The Bright Future of Web 3.0?"
                content="We dive into the next evolution of the web that claims toput the power of the platforms back into the hands of the people.
                But is it really fulfilling its promise?" />
            <SideNews />
        </section>
    )
}

export default MainNews;